import domReady from '@wordpress/dom-ready';
import Swiper from 'swiper';

import 'swiper/css';

domReady(() => {
  const BP = 1200;
  const carousels = document.querySelectorAll(
    '.news-block .news-block__carrousel'
  );

  const instances = new WeakMap();

  const getDesktopConfig = () => ({
    direction: 'vertical',
    centeredSlides: true,
    autoHeight: true,
    watchOverflow: true,
    slidesPerView: 2.28,
    slidesPerGroup: 1,
    spaceBetween: 20,
    loop: true,
    mousewheel: true,
  });

  const initDesktop = (el) => {
    const swiper = new Swiper(el, getDesktopConfig());
    swiper.on('resize', (sw) => {
      sw.update();
      sw.updateSize();
      sw.updateSlides();
      sw.updateAutoHeight();
    });
    instances.set(el, swiper);
  };

  const destroyIfAny = (el) => {
    const inst = instances.get(el);
    if (inst) {
      inst.destroy(true, true);
      instances.delete(el);
    }
  };

  const applyMode = (isDesktop) => {
    carousels.forEach((el) => {
      if (isDesktop) {
        if (!instances.get(el)) {
          initDesktop(el);
        } else {
          const sw = instances.get(el);
          sw.update();
          sw.updateSize();
          sw.updateSlides();
          sw.updateAutoHeight();
        }
      } else {
        destroyIfAny(el);
      }
    });
  };

  if (carousels.length > 0) {
    let isDesktop = window.innerWidth >= BP;
    applyMode(isDesktop);

    const mq = window.matchMedia(`(min-width: ${BP}px)`);
    mq.addEventListener('change', (e) => {
      isDesktop = e.matches;
      applyMode(isDesktop);
    });

    window.addEventListener('resize', () => {
      const nextIsDesktop = window.innerWidth >= BP;
      if (nextIsDesktop !== isDesktop) {
        isDesktop = nextIsDesktop;
        applyMode(isDesktop);
      } else {
        carousels.forEach((el) => {
          const sw = instances.get(el);
          if (sw) {
            sw.update();
            sw.updateSize();
            sw.updateSlides();
            sw.updateAutoHeight();
          }
        });
      }
    });
  }
});
